import { IncentivesCardHomepage } from '@/components/molecules/IncentivesCardHomepage/IncentivesCardHomepage';
import { ShopCard } from '@/components/molecules/ShopCard/ShopCard';
import { FC } from 'react';

export const HomePageCompareCarousel: FC = () => {
  return (
    <section className="flex w-full flex-col gap-l py-[64px]">
      <div className="flex w-full flex-col gap-l m:flex-row">
        <div className="flex w-full m:w-1/2">
          <ShopCard variant="used" />
        </div>
        <div className="flex w-full m:w-1/2">
          <ShopCard variant="new" />
        </div>
      </div>
      {process.env.NEXT_PUBLIC_ENABLE_INCENTIVES_REBATES === 'true' && (
        <div className="flex w-full">
          <IncentivesCardHomepage />
        </div>
      )}
    </section>
  );
};
